var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
import { Color } from '../const';
export var BaseTooltipContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  border-radius: 4px;\n  box-shadow: 0 0 4px 0 ", ";\n  font-size: 13px;\n  max-width: 320px;\n  padding: 6px 8px;\n  line-height: 1.2em;\n"], ["\n  border-radius: 4px;\n  box-shadow: 0 0 4px 0 ", ";\n  font-size: 13px;\n  max-width: 320px;\n  padding: 6px 8px;\n  line-height: 1.2em;\n"])), Color.BLACK_ALPHA30);
export var BaseTooltipArrow = styled.div.attrs({
    className: 'arrow',
})(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  box-shadow: 1px 1px 1px ", ";\n  height: 8px;\n  position: absolute;\n  width: 8px;\n"], ["\n  box-shadow: 1px 1px 1px ", ";\n  height: 8px;\n  position: absolute;\n  width: 8px;\n"])), Color.BLACK_ALPHA20);
var targetOffset = [0, 0];
export var placementBaseConfig = {
    left: {
        points: ['cr', 'cl'],
        offset: [-8, -2],
        targetOffset: targetOffset,
    },
    right: {
        points: ['cl', 'cr'],
        offset: [8, -2],
        targetOffset: targetOffset,
    },
    top: {
        points: ['bc', 'tc'],
        offset: [0, -8],
        targetOffset: targetOffset,
    },
    bottom: {
        points: ['tc', 'bc'],
        offset: [0, 8],
        targetOffset: targetOffset,
    },
    topLeft: {
        points: ['bl', 'tl'],
        offset: [0, -8],
        targetOffset: targetOffset,
    },
    leftTop: {
        points: ['tr', 'tl'],
        offset: [-8, 0],
        targetOffset: targetOffset,
    },
    topRight: {
        points: ['br', 'tr'],
        offset: [0, -8],
        targetOffset: targetOffset,
    },
    rightTop: {
        points: ['tl', 'tr'],
        offset: [8, 0],
        targetOffset: targetOffset,
    },
    bottomRight: {
        points: ['tr', 'br'],
        offset: [0, 8],
        targetOffset: targetOffset,
    },
    rightBottom: {
        points: ['bl', 'br'],
        offset: [8, 0],
        targetOffset: targetOffset,
    },
    bottomLeft: {
        points: ['tl', 'bl'],
        offset: [0, 8],
        targetOffset: targetOffset,
    },
    leftBottom: {
        points: ['br', 'bl'],
        offset: [-8, 0],
        targetOffset: targetOffset,
    },
};
var templateObject_1, templateObject_2;
//# sourceMappingURL=util.js.map